<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2021-07-13 11:33:01
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-02-09 11:46:19
-->
<template>
  <div class="CostProfit">
    <div class="title">
      <img src="@/img/datav/title_icon.png" alt="" />
      <span>成本与毛利润统计</span>
    </div>
    <div
      id="CostProfitChart"
      style="width:680px;height:470px;margin-top:-25px;margin-left:-15px"
    ></div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
let myChart
import { productionSaleTotal } from '@/api/dashboard'
import to from 'await-to'
export default {
  data() {
    return {
      option: {},
    }
  },
  mounted() {
    myChart = echarts.init(document.getElementById('CostProfitChart'))
    myChart.resize()
    window.addEventListener('resize', () => {
      myChart.resize()
    })
    this.initData()
    setInterval(() => {
      this.initData()
    }, process.env.VUE_APP_LTIME)
  },
  methods: {
    async initData() {
      const [res, err] = await to(productionSaleTotal())
      if (err) return
      this.option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(2, 14, 40, 0.95)',
          borderColor: '#03DFFC',
          borderWidth: 2,
          textStyle: {
            color: '#fff',
            fontSize: 16,
          },
          axisPointer: {
            type: 'shadow',
            shadowStyle: {
              color: 'rgba(3, 223, 252, 0.2)',
            },
          },
          formatter: function(params) {
            let html = `<div style="font-size:16px;font-weight:bold;margin-bottom:10px;color:#03DFFC;text-shadow:0 0 10px #03DFFC;">${params[0].name}</div>`
            params.forEach(item => {
              const color = item.seriesName === '成本' ? '#03DFFC' : '#63FBFC'
              html += `<div style="display:flex;align-items:center;margin:8px 0;">
                <span style="display:inline-block;width:12px;height:12px;background:${color};margin-right:10px;box-shadow:0 0 15px ${color};"></span>
                <span style="color:rgba(255,255,255,0.85);font-size:15px;">${item.seriesName}: </span>
                <span style="font-weight:bold;color:#fff;margin-left:10px;font-size:17px;text-shadow:0 0 8px rgba(255,255,255,0.5);">${item.value}</span>
              </div>`
            })
            return html
          },
        },
        legend: {
          right: 70,
          top: 0,
          itemHeight: 20,
          itemWidth: 20,
          icon: 'circle',
          itemGap: 56,
          textStyle: {
            fontSize: 21,
            color: '#899DBF',
            fontFamily: 'Source Han Sans CN',
          },
          data: ['成本', '毛利润'],
        },
        xAxis: {
          type: 'category',
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.45)',
              width: 1,
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontFamily: 'Source Han Sans CN',
            fontSize: 20,
            color: 'rgba(255, 255, 255, 0.49)',
            interval: 0,
          },
          data: res.data.monthList,
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false,
          },
          axisLabel: {
            fontFamily: 'Source Han Sans CN',
            fontSize: 18,
            color: 'rgba(255, 255, 255, 0.49)',
          },
        },
        series: [
          {
            name: '成本',
            data: res.data.productionList,
            type: 'bar',
            stack: 'a',
            barWidth: '55%',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(24, 34, 80, 0.4)',
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#03DFFC' },
                { offset: 0.5, color: '#0F9AD8' },
                { offset: 1, color: '#1B63CC' },
              ]),
              shadowColor: '#03DFFC',
              shadowBlur: 20,
              shadowOffsetY: 0,
            },
            emphasis: {
              itemStyle: {
                shadowColor: '#03DFFC',
                shadowBlur: 40,
                shadowOffsetY: 0,
              },
            },
            animationDuration: 2500,
            animationEasing: 'elasticOut',
            animationDelay: function(idx) {
              return idx * 120
            },
          },
          {
            name: '毛利润',
            data: res.data.saleList,
            type: 'bar',
            stack: 'a',
            barWidth: '55%',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(24, 34, 80, 0.4)',
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#63FBFC' },
                { offset: 0.5, color: '#34D5C4' },
                { offset: 1, color: '#05A998' },
              ]),
              shadowColor: '#63FBFC',
              shadowBlur: 20,
              shadowOffsetY: 0,
            },
            emphasis: {
              itemStyle: {
                shadowColor: '#63FBFC',
                shadowBlur: 40,
                shadowOffsetY: 0,
              },
            },
            animationDuration: 2500,
            animationEasing: 'elasticOut',
            animationDelay: function(idx) {
              return idx * 120 + 250
            },
          },
        ],
      }
      myChart.setOption(this.option)
    },
  },
}
</script>
<style lang="scss" scoped>
.CostProfit {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  padding: 20px 30px;
  .title {
    width: 550px;
    position: relative;
    font-size: 26px;
    color: #ecf8ff;
    display: flex;
    align-items: center;
    img {
      margin-right: 3px;
    }
  }
}
</style>
